import { getJSON, postJSON, deleteJSON } from 'bv-fetch';

export const postFavoriteGame = (id) => postJSON('/api/casino/favorite_games', { id });
export const deleteFavoriteGame = (id) => deleteJSON(`/api/casino/favorite_games/${id}`);
export const fetchFavoriteGames = () => getJSON('/api/casino/favorite_games');
